import { useEffect, useState } from 'react';

export type MenuVisibility = 'all' | 'no-time' | 'drag-only' | 'none';

interface WidthBreakpoint {
  minWidth: number;
  visibility: MenuVisibility;
}

export const MENU_BREAKPOINTS_WITH_DRAG: WidthBreakpoint[] = [
  { minWidth: 120, visibility: 'all' },
  { minWidth: 70, visibility: 'no-time' },
  { minWidth: 44, visibility: 'drag-only' }
];

export const MENU_BREAKPOINTS_WITHOUT_DRAG: WidthBreakpoint[] = [
  { minWidth: 90, visibility: 'all' },
  { minWidth: 44, visibility: 'no-time' }
];

export function useMenuVisibility(
  ref: React.RefObject<HTMLElement | null>,
  breakpoints: WidthBreakpoint[]
): MenuVisibility {
  const [menuVisibility, setMenuVisibility] = useState<MenuVisibility>('all');

  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    const sorted = [...breakpoints].sort((a, b) => b.minWidth - a.minWidth);
    const observer = new ResizeObserver(([entry]) => {
      const w = entry.contentRect.width;
      const match = sorted.find(bp => w >= bp.minWidth);
      setMenuVisibility(match ? match.visibility : 'none');
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref, breakpoints]);

  return menuVisibility;
}
